<template>
  <div>
    <h1>{{ $t("delegation.settlementList.title") }}</h1>
    <delegation-menu></delegation-menu>
    <v-row style="margin-bottom: 15px">
      <v-col cols="3">
        <v-text-field :label="$t('global.search')" append-icon="search" hide-details single-line v-model="search"></v-text-field>
      </v-col>
      <v-spacer></v-spacer>
      <div>
        <v-btn block color="accent" to="/delegation/start" v-if="hasPermissionForNewDelegation">{{ $t("delegation.settlementList.new") }}</v-btn>
      </div>
    </v-row>
    <v-data-table :headers="headers" :items="delegation" :search="search" :loading="$store.getters['Ajax/loading'] ? 'accent' : false">
      <template #item="props">
        <tr>
          <td class="text-left">
            <document-number :number="props.item.number" :temp-number="props.item.custom_number"> </document-number>
          </td>
          <td class="text-left">
            {{ !!props.item.delegated_user ? props.item.delegated_user : $t("general.notSet") }}
          </td>
          <td class="text-left">
            {{ !!props.item.date_start ? props.item.date_start : $t("general.notSet") }}
          </td>
          <td class="text-left">
            {{ !!props.item.date_end ? props.item.date_end : $t("general.notSet") }}
          </td>
          <td class="text-center">
            <delegation-status-chip :status="props.item.status"></delegation-status-chip>
          </td>
          <td class="text-center">
            <action-list :action-list="props.item.actions" :context-item-id="props.item.id"> </action-list>
          </td>
        </tr>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import ActionList from "../../components/Actions/ActionList.vue";
import DelegationMenu from "../../components/DelegationMenu.vue";
import DocumentNumber from "../../components/Shared/DocumentNumber.vue";
import DelegationStatusChip from "../../components/Delegation/DelegationStatusChip";

export default {
  name: "DelegationView",
  components: {
    DelegationStatusChip,
    DocumentNumber,
    DelegationMenu,
    ActionList
  },
  data: () => ({
    search: ""
  }),
  computed: {
    delegation() {
      return this.$store.getters["Delegation/delegationList"];
    },
    hasPermissionForNewDelegation() {
      return (
        this.$store.getters.hasPermission("createDelegationSelf") ||
        this.$store.getters.hasPermission("createDelegationAll") ||
        this.$store.getters.hasPermission("SuperAdmin") ||
        this.$store.getters.hasPermission("companyAdmin")
      );
    },
    headers() {
      return [
        { text: this.$t("delegation.number"), value: "number" },
        { text: this.$t("delegation.delegated"), value: "delegated_user" },
        { text: this.$t("delegation.startDate"), value: "date_start" },
        { text: this.$t("delegation.endDate"), value: "date_end" },
        { text: this.$t("delegation.status"), value: "status", align: "center" },
        { text: this.$t("global.actions"), sortable: false, value: "actions", align: "center" }
      ];
    }
  },
  methods: {},
  created() {
    this.$store.dispatch("Delegation/loadAllDelegations");
  }
};
</script>

<style scoped></style>
